"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.HangerOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M13 10.5a2.5 2.5 0 0 1 5 0c0 .701-.156 1.023-.393 1.271-.303.317-.84.621-1.866 1.05a2.015 2.015 0 0 0-1.241 1.856v1.311l.001.06a1 1 0 0 0 .514.827L27.286 24H4.507l8.298-5.15a1 1 0 1 0-1.054-1.7L3.453 22.3c-1.71 1.062-.958 3.7 1.054 3.7h22.78c2.043 0 2.77-2.703 1.004-3.73L16.5 15.424v-.748a.029.029 0 0 1 .014-.01c1.015-.425 1.915-.861 2.538-1.512.688-.72.948-1.593.948-2.654a4.5 4.5 0 1 0-9 0 1 1 0 1 0 2 0z" stroke="none"></path>';
var HangerOutlineSVG = function HangerOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.HangerOutlineSVG = HangerOutlineSVG;
HangerOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(HangerOutlineSVG);
exports.default = _default;